/**
 * Created by jv on 2019-11-14 (12:30).
 */
require("Libs/selectize/selectize-default.css");
const selectize = require("Libs/selectize/selectize");

import utils from "Sources/utils/utils";

let FormUtils = {};

(FormUtils =>
{
  FormUtils.setUpSelectize = function(selector, data, placeholder)
  {
    let $el = $(selector);

    if(utils.isNotNull($el) && $el.length)
    {
      if(utils.isNotNull($el[0].selectize))
      {
        $el[0].selectize.destroy();
      }

      $el.empty();

      if(!utils.isNullOrEmpty(placeholder))
      {
        // Empty option tag is needed as placeholder for selectize
        $el.append("<option></option>");
      }

        for (let i = 0; i < data.length; i++)
        {
            $el.append("<option value='" + data[i].value + "' " + (data[i].default ? "selected" : "") + ">" + data[i].text + "</option>");
        }

        const $select = $el.selectize({
            placeholder: placeholder
        });
        return $select[0].selectize;
    }

      return undefined;
  };
})(FormUtils);

export default FormUtils;



// WEBPACK FOOTER //
// ./app/js/utils/form-utils.js